export function chatIdInArray(chatId, items) {
  return items.filter((item) => item._id === chatId).length > 0;
}

export function chatInArray(chat, items) {
  return chatIdInArray(chat._id, items);
}
